module.exports = __webpack_public_path__ + "fonts/1c89e4cc/proximanova-light-webfont.ttf";